(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./_util/proptype"));
	else if(typeof define === 'function' && define.amd)
		define(["./_util/proptype"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./_util/proptype")) : factory(root["./_util/proptype"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 40);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/defineProperty");

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _style_index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(122);
/* harmony import */ var _style_index_less__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_style_index_less__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(145);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_1__);



/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./components/button/style/index.js
var style = __webpack_require__(25);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./components/button/button.vue?vue&type=template&id=5350d404&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.classes,
      attrs: { type: _vm.htmlType },
      on: {
        click: _vm.handleClick,
        mouseup: _vm.handleMouseUp,
        mousedown: _vm.handleMouseDown
      }
    },
    [
      _vm.iconType
        ? _c("mds-icon", { attrs: { type: _vm.iconType } })
        : _vm._e(),
      !_vm.shape && _vm.justText
        ? _c("span", [_vm._t("default")], 2)
        : _vm._e(),
      !_vm.shape && !_vm.justText ? _vm._t("default") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./components/button/button.vue?vue&type=template&id=5350d404&

// EXTERNAL MODULE: external "babel-runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "./_util/proptype"
var proptype_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./components/button/button.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var SIZEMAP = {
  small: 'sm',
  large: 'lg',
  'large-small': 'ls'
};

/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
  name: 'MdsButton',
  props: {
    ghost: {
      type: Boolean,
      default: false
    },
    htmlType: {
      type: String,
      default: 'button'
    },
    icon: String,
    loading: {
      type: [Boolean, Object],
      default: false
    },
    shape: {
      type: String,
      validator: function validator(value) {
        return Object(proptype_["oneOf"])(value, ['circle', 'circle-outline']);
      }
    },
    size: {
      type: String,
      validator: function validator(value) {
        return Object(proptype_["oneOf"])(value, ['small', 'large', '', 'large-small']);
      }
    },
    type: {
      type: String,
      validator: function validator(value) {
        return Object(proptype_["oneOf"])(value, ['primary', 'dashed', 'danger', 'default', 'text', 'normal', 'correct', 'warning', 'info']);
      }
    },
    block: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      prefixCls: 'mds-btn',
      clicked: false,
      timeout: null,
      delayTimeout: null,
      isLoading: false,
      justText: false
    };
  },

  computed: {
    children: function children() {
      return this.$slots.default;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls;
      var size = this.size && SIZEMAP[this.size];
      var loading = this.loading ? 'loading' : 'load';
      return ['' + prefixCls, (_ref = {}, defineProperty_default()(_ref, prefixCls + '-' + loading, !!this.isLoading), defineProperty_default()(_ref, prefixCls + '-' + this.type, !!this.type), defineProperty_default()(_ref, prefixCls + '-' + this.shape, !!this.shape), defineProperty_default()(_ref, prefixCls + '-' + size, !!size), defineProperty_default()(_ref, prefixCls + '-background-ghost', !!this.ghost), defineProperty_default()(_ref, prefixCls + '-clicked', !!this.clicked), defineProperty_default()(_ref, prefixCls + '-icon-only', !this.children && this.icon && !this.loading), defineProperty_default()(_ref, prefixCls + '-block', !!this.block), defineProperty_default()(_ref, prefixCls + '-round', !!this.round), _ref)];
    },
    iconType: function iconType() {
      return this.icon;
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      var _this = this;

      this.clicked = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this.clicked = false;
      }, 500);
      this.$emit('click', e);
    },

    // Handle auto focus when click button in Chrome
    handleMouseUp: function handleMouseUp(e) {
      e.currentTarget.blur();
      this.$emit('mouseup', e);
    },
    handleMouseDown: function handleMouseDown(e) {
      this.$emit('mousedown', e);
    }
  },
  watch: {
    loading: function loading(next, cur) {
      var _this2 = this;

      cur && this.delayTimeout && clearTimeout(this.delayTimeout);
      if (typeof next !== 'boolean' && next && next.delay) {
        this.delayTimeout = setTimeout(function () {
          return _this2.isLoading = true;
        }, next.delay);
      } else {
        this.isLoading = true;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.timeout && clearTimeout(this.timeout);
    this.delayTimeout && clearTimeout(this.delayTimeout);
  },
  created: function created() {
    this.isLoading = this.loading;

    var children = this.$slots.default;
    children && children.length === 1 && children[0].text && (this.justText = true);
  }
});
// CONCATENATED MODULE: ./components/button/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var button_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./components/button/button.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  button_buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "components/button/button.vue"
/* harmony default export */ var button_button = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./components/button/button-group.vue?vue&type=template&id=16f19476&
var button_groupvue_type_template_id_16f19476_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [_vm._t("default")], 2)
}
var button_groupvue_type_template_id_16f19476_staticRenderFns = []
button_groupvue_type_template_id_16f19476_render._withStripped = true


// CONCATENATED MODULE: ./components/button/button-group.vue?vue&type=template&id=16f19476&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./components/button/button-group.vue?vue&type=script&lang=js&

//
//
//
//
//
//



var button_groupvue_type_script_lang_js_SIZEMAP = {
  'small': 'sm',
  'large': 'lg',
  'large-small': 'ls'
};

/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
  name: 'MdsBtnGroup',
  props: {
    size: {
      type: String,
      validator: function validator(value) {
        return Object(proptype_["oneOf"])(value, ['small', 'large', 'large-small']);
      }
    }
  },
  data: function data() {
    return {
      prefixCls: 'mds-btn-group'
    };
  },

  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls;
      var size = this.size && button_groupvue_type_script_lang_js_SIZEMAP[this.size];
      return ['' + prefixCls, defineProperty_default()({}, prefixCls + '-' + size, !!size)];
    }
  }
});
// CONCATENATED MODULE: ./components/button/button-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var button_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/button/button-group.vue





/* normalize component */

var button_group_component = Object(componentNormalizer["a" /* default */])(
  button_button_groupvue_type_script_lang_js_,
  button_groupvue_type_template_id_16f19476_render,
  button_groupvue_type_template_id_16f19476_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var button_group_api; }
button_group_component.options.__file = "components/button/button-group.vue"
/* harmony default export */ var button_group = (button_group_component.exports);
// CONCATENATED MODULE: ./components/button/index.js




button_button.Group = button_group;
/* istanbul ignore next */
button_button.install = function (Vue) {
  Vue.component(button_button.name, button_button);
  Vue.component(button_group.name, button_group);
};
/* harmony default export */ var components_button = __webpack_exports__["default"] = (button_button);

/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bic-fe/mds-ui/dist/button.js
// module id = u6ap
// module chunks = 0